import { render, staticRenderFns } from "./editScheduleClassesList.vue?vue&type=template&id=01e45050&scoped=true"
import script from "./editScheduleClassesList.vue?vue&type=script&lang=js"
export * from "./editScheduleClassesList.vue?vue&type=script&lang=js"
import style0 from "./editScheduleClassesList.vue?vue&type=style&index=0&id=01e45050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e45050",
  null
  
)

export default component.exports